import { PhaseCompletionStatus } from "./models/PhaseCompletionStatus";

export enum PhaseCompletionStatusIssue {
  Issue = "Issue",
}

export type PhaseCompletionStatusExtended = PhaseCompletionStatus | PhaseCompletionStatusIssue.Issue;
